import {DotFillIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './CompactComment.module.css'
import {getCommentSnippet} from '../util/get-comment-snippet'

export function CompactComment({
  isPending,
  author,
  body,
  emphasized = false,
}: {
  body: string
  isPending: boolean
  author?: {
    login: string
    avatarUrl?: string | null
  } | null
  emphasized?: boolean
}) {
  const login = author?.login ?? 'ghost'
  return (
    <div className={styles.commentRow}>
      {isPending ? (
        <PendingCommentIcon />
      ) : (
        <GitHubAvatar src={author?.avatarUrl ?? ''} size={16} alt="" className={styles.avatar} />
      )}
      <span className={styles.commentText}>
        <span className={emphasized ? styles.authorEmphasized : styles.author}>{login}</span>
        <span className={clsx(styles.snippet, isPending && styles.pending)}>{getCommentSnippet(body)}</span>
      </span>
    </div>
  )
}
function PendingCommentIcon() {
  return (
    <span className={styles.pendingIconLabel}>
      <DotFillIcon size={12} />
      <span className="sr-only">Pending: </span>
    </span>
  )
}
